import React from "react";

import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import { AccessoryNoteCard } from "./AccessoriesCards";
import { roofKey } from "./BoxStructureCards";

const AccessoriesSafety = () => (
  <>
    <StructureSection titleKey={roofKey("SECTIONS.SAFETY")}>
      <CardRow columns={3}>
        <AccessoryNoteCard
          cardKey="rearBumper"
          titleKey={roofKey("CARDS.REAR_BUMPER")}
        />
        <AccessoryNoteCard
          cardKey="hazmatSigns"
          titleKey={roofKey("CARDS.HAZMAT_SIGNS")}
        />
        <AccessoryNoteCard
          cardKey="spareWheelCarrier"
          titleKey={roofKey("CARDS.SPARE_WHEEL_CARRIER")}
        />
      </CardRow>
      <CardRow columns={2}>
        <AccessoryNoteCard
          cardKey="rearLightProtectionFrame"
          titleKey={roofKey("CARDS.REAR_LIGHT_PROTECTION_FRAME")}
        />
        <AccessoryNoteCard
          cardKey="extinguisherMount"
          titleKey={roofKey("CARDS.EXTINGUISHER_MOUNT")}
        />
      </CardRow>
    </StructureSection>

    <StructureSection titleKey={roofKey("SECTIONS.VEHICLE_ADDONS")}>
      <CardRow columns={2}>
        <AccessoryNoteCard cardKey="wings" titleKey={roofKey("CARDS.WINGS")} />
        <AccessoryNoteCard
          cardKey="roundIronSides"
          titleKey={roofKey("CARDS.ROUND_IRON_SIDES")}
        />
      </CardRow>
    </StructureSection>
  </>
);

export default AccessoriesSafety;
